import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskTicketTypesConfigRoute: InvariantJiraRoute = {
	exact: true,
	name: 'project-settings-servicedesk-ticket-types-config',
	path: '/jira/servicedesk/projects/:projectKey/settings/request-types',
};
